import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ConfirmationDialog = ({
  openConfirmDialog,
  handleCloseDialog,
  dialogAction,
  mode,
  handleSubmit,
}) => {
  const navigate = useNavigate();

  const isSubmitDialog = dialogAction === "submit";
  const title = isSubmitDialog ? "Confirm Submission" : "Discard Changes?";
  const message = isSubmitDialog
    ? `Are you sure you want to ${
        mode === "edit" ? "update" : "add"
      } this user?`
    : "You have unsaved changes. Are you sure you want to discard them?";
  const confirmButtonText = isSubmitDialog ? "Confirm" : "Discard";
  const confirmAction = isSubmitDialog
    ? handleSubmit
    : () => navigate("/users/all");

  return (
    <Dialog
      open={openConfirmDialog}
      onClose={handleCloseDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} color="primary">
          Cancel
        </Button>
        <Button onClick={confirmAction} color="primary" autoFocus>
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
